
import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit';
import {
  fetchUpvoteFeaturedArticleStatus,
  toggleUpvoteFeaturedArticle,
} from '../actions/featuredArticlesUpvoteActions';

const initialState: BlogUpvoteStatusType = {
  total_upvotes: 0,
  user_has_upvoted: false,
  loading: false,
  error: null,
};

const featuredArticleUpvoteSlice = createSlice({
  name: 'featuredArticleUpvote',
  initialState,
  reducers: {},
  extraReducers: builder => {
    getFeaturedArticleUpvoteStatus(builder);
    handleFeaturedArticleUpvoteToggle(builder);
  },
});

const getFeaturedArticleUpvoteStatus = (
  builder: ActionReducerMapBuilder<BlogUpvoteStatusType>
) => {
  builder.addCase(
    fetchUpvoteFeaturedArticleStatus.pending,
    (state: BlogUpvoteStatusType) => {
      state.loading = true;
      state.error = null;
    }
  );
  builder.addCase(fetchUpvoteFeaturedArticleStatus.fulfilled, (state, action) => {
    state.loading = false;
    state.total_upvotes = action.payload.total_upvotes;
    state.user_has_upvoted = action.payload.user_has_upvoted;
  });
  builder.addCase(fetchUpvoteFeaturedArticleStatus.rejected, (state, { error }) => {
    state.loading = false;
    state.error = error.message || 'Failed to fetch article upvotes';
  });
};

const handleFeaturedArticleUpvoteToggle = (
  builder: ActionReducerMapBuilder<BlogUpvoteStatusType>
) => {
  builder
    .addCase(toggleUpvoteFeaturedArticle.pending, state => {
      // Optimistic update: flip immediately
      state.user_has_upvoted = !state.user_has_upvoted;
      state.total_upvotes = state.user_has_upvoted
        ? state.total_upvotes + 1
        : state.total_upvotes - 1;
      state.loading = true;
      state.error = null;
    })
    .addCase(toggleUpvoteFeaturedArticle.fulfilled, (state, action) => {
      state.loading = false;
      state.total_upvotes = action.payload.total_upvotes;
      state.user_has_upvoted = action.payload.user_has_upvoted;
    })
    .addCase(toggleUpvoteFeaturedArticle.rejected, (state, { error }) => {
      // Revert optimistic update
      state.user_has_upvoted = !state.user_has_upvoted;
      state.total_upvotes = state.user_has_upvoted
        ? state.total_upvotes + 1
        : state.total_upvotes - 1;
      state.loading = false;
      state.error = error.message || 'Failed to toggle article upvote';
    });
};

export default featuredArticleUpvoteSlice.reducer;